<button class="custom-button d-flex align-items-center justify-content-center" [disabled]="disabled() || loading()" [ngClass]="[type(), size(), shape(), theme()]" [class.inverted]="inverted()" [class.w-100]="fullWidth()" (click)="buttonPressed($event)" [type]="buttonType()">
    @if(loading())
    {
        <mat-spinner />
    }
    @else 
    {
        @if (!!label())
        {
            <span class="button-label nunito-semibold" [class.text-decoration-none]="!textDecoration()">{{label() | translate}}</span>
        }
        @if (!!icon())
        {
            <svg-icon [src]="'assets/icons/' + icon() + '.svg'" class="button-icon d-flex align-items-center justify-content-center" />
        }
    }
</button>
